import { combineEpics } from 'redux-observable'

import activityFeedEpics from './ActivityFeed/epics'
import campaignsEpics from './Campaigns/epics'
import deepfakeEpics from './Deepfake/epics'
import emailOverviewEpics from './EmailOverview/epics'
import insightWidgetEpics from './InsightWidget/epics'
import mailboxesStatusEpics from './MailboxesStatus/epics'
import phishingWidgetEpics from './PhishingWidget/epics'
import resolutionCenterEpics from './ResolutionCenter/epics'
import resolvedIncidentWidgetEpics from './ResolvedIncidentWidget/epics'
import threatTypesEpics from './ThreatTypes/epics'
import urgentUnclassifiedIncidentsEpics from './UrgentUnclassifiedIncidentsWidget/epics'

export default combineEpics(
  resolutionCenterEpics,
  campaignsEpics,
  activityFeedEpics,
  mailboxesStatusEpics,
  threatTypesEpics,
  emailOverviewEpics,
  deepfakeEpics,
  phishingWidgetEpics,
  insightWidgetEpics,
  urgentUnclassifiedIncidentsEpics,
  resolvedIncidentWidgetEpics
)
